<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <!--<button-add :pathName="addCustom"/>-->
        <div class="btn-box">
          <span style="margin-right: 10px">付费时间</span>
          <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                          :picker-options="pickerOptions3" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-select :selectTitle="'付费状态'" style="margin-left: 10px;" :selectData="payStatusList" @search="search" :selectKey="'status'" />
      </div>
      <div class="btn-box">
        <input-search placeholder="付费人姓名/手机号/车牌号" @search="searchKey" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          style="margin-left: 10px"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('013013001') !== -1"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import bus from "../../../utils/bus";
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'parking-finance-temporary-stop',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '临停收费'
        }],
        // addCustom: 'amount-add',
        exportUrl: '',
        timevalue: [],
        pickerOptions3: {
          shortcuts: [{
            text: '过去一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        payTypeList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '月缴'
        }, {
          key: '2',
          label: '季缴'
        }, {
          key: '3',
          label: '半年缴'
        }, {
          key: '4',
          label: '年缴'
        }],
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }],
        tableHead: [{
          prop: 'carNumber',
          label: '车牌号'
        }, {
          prop: 'parkingDuration',
          label: '停车时长'
        }, {
          prop: 'money',
          label: '付费金额'
        }, {
          prop: 'statusText',
          label: '付费状态',
        }, {
          prop: 'consumeTime',
          label: '付费时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          status: '',
          startTime: '',
          endTime: '',
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportTempraryRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getTempraryRecordPage, reqData)
          .then(res => {
            if (res.data.retCode == 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.payTime) {
                  v.payTime = v.payTime.slice(0, 19)
                }
                if (v.status === '0') {
                  v.statusText = '未缴费'
                } else if (v.status === '1') {
                  v.statusText = '已缴费'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      }
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/ParkingFinance/ParkingFinanceTemporaryStop.vue